"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _underscore = require("underscore");

var _generalStore = require("general-store");

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _EngagementAssociationsConstants = require("crm_data/associations/EngagementAssociationsConstants");

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _ElasticSearchConstants = require("customer-data-objects/search/ElasticSearchConstants");

var _MultipleAssociationsDependency = _interopRequireDefault(require("customer-data-communicator/data/associations/dependencies/MultipleAssociationsDependency"));

var _ElasticSearchValidation = require("crm_data/elasticSearch/ElasticSearchValidation");

var _debounce = _interopRequireDefault(require("transmute/debounce"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _LoadingStatus = require("crm_data/flux/LoadingStatus");

var _some = _interopRequireDefault(require("transmute/some"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var multipleAssociationsDependencyProps = {
  subject: _SubjectType.default,
  subjectId: _react.PropTypes.string
};
var componentPropTypes = (0, _extends2.default)({
  buttonUse: _react.PropTypes.string,
  className: _react.PropTypes.string,
  handleRemove: _react.PropTypes.func.isRequired,
  handleSelect: _react.PropTypes.func.isRequired,
  menuWidth: _react.PropTypes.number,
  minimumSearchLength: _react.PropTypes.number,
  onCloseSelect: _react.PropTypes.func,
  onOpenSelect: _react.PropTypes.func,
  optionMatches: _react.PropTypes.array,
  placeholderText: _react.PropTypes.node,
  values: _react.PropTypes.object
}, multipleAssociationsDependencyProps);
var searchPropTypes = {
  searchText: _react.PropTypes.string.isRequired,
  setSearchText: _react.PropTypes.func.isRequired,
  debouncedSearchTextForElasticSearch: _react.PropTypes.string.isRequired,
  setDebouncedSearchTextForElasticSearch: _react.PropTypes.func.isRequired
};
var propTypes = (0, _extends2.default)({}, componentPropTypes, searchPropTypes);
var defaultProps = {
  minimumSearchLength: _ElasticSearchConstants.MIN_SEARCH_LENGTH,
  onCloseSelect: _emptyFunction.default,
  onOpenSelect: _emptyFunction.default,
  buttonUse: 'transparent',
  menuWidth: _EngagementAssociationsConstants.SELECT_MENU_WIDTH
};

var MultipleAssociationsSelectContent =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(MultipleAssociationsSelectContent, _PureComponent);

  function MultipleAssociationsSelectContent(props) {
    var _this;

    (0, _classCallCheck2.default)(this, MultipleAssociationsSelectContent);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MultipleAssociationsSelectContent).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.handleDebouncedSearchTextChange = (0, _debounce.default)(200, _this.handleSearchTextForElasticSearchChange);
    return _this;
  }

  (0, _createClass2.default)(MultipleAssociationsSelectContent, [{
    key: "parseValue",
    value: function parseValue(value) {
      if (!value || value.length === 0) {
        return undefined;
      }

      var _first$split = (0, _underscore.first)(value).split(' '),
          _first$split2 = (0, _slicedToArray2.default)(_first$split, 2),
          objectType = _first$split2[0],
          subjectId = _first$split2[1];

      return [objectType, Number(subjectId)];
    }
  }, {
    key: "addValue",
    value: function addValue(value) {
      var _this$parseValue = this.parseValue(value),
          _this$parseValue2 = (0, _slicedToArray2.default)(_this$parseValue, 2),
          objectType = _this$parseValue2[0],
          subjectId = _this$parseValue2[1];

      this.props.handleSelect(objectType, subjectId);
    }
  }, {
    key: "removeValue",
    value: function removeValue(removedValue) {
      var _this$parseValue3 = this.parseValue(removedValue),
          _this$parseValue4 = (0, _slicedToArray2.default)(_this$parseValue3, 2),
          objectType = _this$parseValue4[0],
          subjectId = _this$parseValue4[1];

      this.props.handleRemove(objectType, subjectId);
    }
  }, {
    key: "handleSearchTextForElasticSearchChange",
    value: function handleSearchTextForElasticSearchChange(debouncedSearchTextForElasticSearch) {
      this.props.setDebouncedSearchTextForElasticSearch(debouncedSearchTextForElasticSearch);
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(_ref) {
      var value = _ref.target.value;
      var flatValues = this.getFlattenedValues();
      var addedValue = (0, _underscore.difference)(value, flatValues);
      var removedValue = (0, _underscore.difference)(flatValues, value);

      if (addedValue.length) {
        return this.addValue(addedValue);
      }

      return this.removeValue(removedValue);
    }
  }, {
    key: "handleInputValueChange",
    value: function handleInputValueChange(evt) {
      var searchText = evt.target.value;
      this.props.setSearchText(searchText);
      this.handleDebouncedSearchTextChange(searchText);
    }
  }, {
    key: "handleOpenChange",
    value: function handleOpenChange(state) {
      var isOpening = state.target.value;

      if (isOpening) {
        this.props.setSearchText('');
        this.props.setDebouncedSearchTextForElasticSearch('');
        this.props.onOpenSelect();
      } else {
        this.props.onCloseSelect();
      }
    }
  }, {
    key: "getNoResultsText",
    value: function getNoResultsText() {
      var _this$props = this.props,
          minimumSearchLength = _this$props.minimumSearchLength,
          searchText = _this$props.searchText;
      var searchLength = searchText.length;

      if (searchLength > 0 && searchLength < minimumSearchLength && !(0, _ElasticSearchValidation.isCjkCharacterContained)(searchText)) {
        var charsNeeded = minimumSearchLength - searchLength;
        return _I18n.default.text('salesUI.UISearchInput.minimumSearchMessage', {
          count: charsNeeded
        });
      }

      return undefined;
    }
  }, {
    key: "getPlaceholderText",
    value: function getPlaceholderText() {
      var values = this.props.values;
      var initialAssociationsCount = 0;

      if (!values) {
        return null;
      }

      var number = Object.keys(values).reduce(function (acc, objectType) {
        return acc + values[objectType].length;
      }, initialAssociationsCount);
      var key = number > 0 ? 'some' : 'none';
      return _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "customerDataCommunicator.MultipleAssociationsSelect.placeholderText." + key,
        options: {
          count: number
        }
      });
    }
  }, {
    key: "getFlattenedValues",
    value: function getFlattenedValues() {
      var values = this.props.values;
      return Object.keys(values).reduce(function (acc, objectType) {
        acc = acc.concat(values[objectType]);
        return acc;
      }, []);
    }
  }, {
    key: "isLoadingResults",
    value: function isLoadingResults() {
      return (0, _some.default)(function (optionMatch) {
        return (0, _LoadingStatus.isLoading)(optionMatch.options);
      }, this.props.optionMatches);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          optionMatches = _this$props2.optionMatches,
          onCloseSelect = _this$props2.onCloseSelect,
          onOpenSelect = _this$props2.onOpenSelect,
          placeholderText = _this$props2.placeholderText,
          className = _this$props2.className,
          buttonUse = _this$props2.buttonUse,
          menuWidth = _this$props2.menuWidth;
      return _react.default.createElement(_UIFlex.default, {
        align: "center"
      }, _react.default.createElement(_UISelect.default, {
        "data-selenium-test": "timeline-header-actions__associations-select",
        anchorType: "button",
        backspaceRemoves: false,
        multi: true,
        buttonUse: buttonUse,
        className: className,
        menuWidth: menuWidth,
        minimumSearchCount: 0,
        onClose: onCloseSelect,
        onOpen: onOpenSelect,
        onChange: this.handleSelect,
        onOpenChange: this.handleOpenChange,
        placement: "top left",
        onInputValueChange: this.handleInputValueChange,
        isLoading: this.isLoadingResults(),
        placeholder: placeholderText || this.getPlaceholderText(),
        _forcePlaceholder: true,
        value: this.getFlattenedValues(),
        noResultsText: this.getNoResultsText(),
        options: optionMatches,
        searchPlaceholder: _I18n.default.text('customerDataCommunicator.MultipleAssociationsSelect.placeholderSearch')
      }));
    }
  }]);
  return MultipleAssociationsSelectContent;
}(_PureComponent2.default);

MultipleAssociationsSelectContent.propTypes = propTypes;
MultipleAssociationsSelectContent.componentPropTypes = componentPropTypes;
MultipleAssociationsSelectContent.defaultProps = defaultProps;

var _default = (0, _generalStore.connect)({
  optionMatches: _MultipleAssociationsDependency.default
})(MultipleAssociationsSelectContent);

exports.default = _default;
module.exports = exports.default;